import React from 'react';
import { Cardapio } from 'modulos/cardapio/containers';

export const CardapioConfiguracoes = () => {
  return <Cardapio visualizacao="configuracao" />;
};
